import {container} from 'inversify-props';

import {IApiService} from '@/services/IApi.service';

import {IAuthService} from '@/services/IAuth.service';
import {IEventsService} from '@/services/IEvents.service';

import {IIdentityUserService} from '@/services/identity/IIdentityUserService';

import {ISystemTimeService} from '@/services/system/ITime.service';
import {ISystemStatsService} from '@/services/system/IStats.service';
import {ISystemOsService} from '@/services/system/IOs.service';
import {ISystemLogService} from '@/services/system/ILog.service';
import {ISystemInfoService} from '@/services/system/IInfo.service';
import {ISystemHardwareService} from '@/services/system/IHardware.service';
import {ISystemCertificateService} from '@/services/system/ICertificate.service';
import {ISystemUpgradeService} from '@/services/system/IUpgrade.service';
import {ISystemUpdateService} from '@/services/system/IUpdate.service';
import {ISystemStorageService} from '@/services/system/ISystemStorage.service';

import {ILoraHardwareService} from '@/services/lora/ILoraHardware.service';
import {ILoraForwarderChirpStackService} from '@/services/lora/forwarder/ILoraForwarderChirpStackService.service';
import {ILoraForwarderLoriotService} from '@/services/lora/forwarder/ILoraForwarderLoriot.service';
import {ILoraForwarderUdpService} from '@/services/lora/forwarder/ILoraForwarderUdp.service';
import {ILoraForwardersService} from '@/services/lora/ILoraForwarders.service';
import {ILoraForwarderBasicStationService} from '@/services/lora/forwarder/BasicStation/ILoraForwarderBasicStation.service';

import {INetworkConnectionService} from '@/services/network/INetworkConnectionService';
import {INetworkDeviceService} from '@/services/network/INetworkDeviceService';
import {INetworkNetworkingService} from '@/services/network/INetworkNetworkingService';
import {INetworkProfileService} from '@/services/network/INetworkProfileService';

import {IGatewaySettingsService} from '@/services/settings/IGatewaySettings.service';
import {ISettingsService} from '@/services/settings/ISettings.service';
import {ILocalSettingsService} from '@/services/settings/ILocalSettingsService';


import {ApiService} from '@/services/Api.service';
import {AuthService} from '@/services/Auth.service';
import {EventsService} from '@/services/Events.service';

import {IdentityUserService} from '@/services/identity/IdentityUserService';

import {LoraForwardersService} from '@/services/lora/LoraForwarders.service';
import {LoraHardwareService} from '@/services/lora/LoraHardware.service';
import {LoraForwarderChirpStackService} from '@/services/lora/forwarder/LoraForwarderChirpStack.service';
import {LoraForwarderLoriotService} from '@/services/lora/forwarder/LoraForwarderLoriot.service';
import {LoraForwarderUdpService} from '@/services/lora/forwarder/LoraForwarderUdp.service';
import {LoraForwarderBasicStationService} from '@/services/lora/forwarder/BasicStation/LoraForwarderBasicStation.service';

import {NetworkConnectionService} from '@/services/network/NetworkConnectionService';
import {NetworkDeviceService} from '@/services/network/NetworkDeviceService';
import {NetworkProfileService} from '@/services/network/NetworkProfileService';
import {NetworkNetworkingService} from '@/services/network/NetworkNetworkingService';

import {SystemCertificateService} from '@/services/system/Certificate.service';
import {SystemHardwareService} from '@/services/system/Hardware.service';
import {SystemInfoService} from '@/services/system/Info.service';
import {SystemLogService} from '@/services/system/Log.service';
import {SystemOsService} from '@/services/system/Os.service';
import {SystemStatsService} from '@/services/system/Stats.service';
import {SystemTimeService} from '@/services/system/Time.service';
import {SystemUpgradeService} from '@/services/system/Upgrade.service';
import {SystemUpdateService} from '@/services/system/Update.service';
import {SystemStorageService} from '@/services/system/Storage.service';

import {GatewaySettingsService} from '@/services/settings/GatewaySettings.service';
import {LocalSettingsService} from '@/services/settings/LocalSettings.service';
import {SettingsService} from '@/services/settings/Settings.service';

import {AuthStore} from '@/store/Auth.store';
import {MessagingStore} from '@/store/Messaging.store';

export function buildDependencyContainer(): void {

  container.addSingleton<IApiService>(ApiService, Symbol.for('IApiService'));
  container.addSingleton<IAuthService>(AuthService, Symbol.for('IAuthService'));
  container.addSingleton<IEventsService>(EventsService, Symbol.for('IEventsService'));

  container.addTransient<IIdentityUserService>(IdentityUserService, Symbol.for('IIdentityUserService'));

  container.addTransient<ILoraHardwareService>(LoraHardwareService, Symbol.for('ILoraHardwareService'));
  container.addTransient<ILoraForwardersService>(LoraForwardersService, Symbol.for('ILoraForwardersService'));
  container.addTransient<ILoraForwarderUdpService>(LoraForwarderUdpService, Symbol.for('ILoraForwarderUdpService'));
  container.addTransient<ILoraForwarderLoriotService>(LoraForwarderLoriotService, Symbol.for('ILoraForwarderLoriotService'));
  container.addTransient<ILoraForwarderChirpStackService>(LoraForwarderChirpStackService, Symbol.for('ILoraForwarderChirpStackService'));
  container.addTransient<ILoraForwarderBasicStationService>(LoraForwarderBasicStationService, Symbol.for('ILoraForwarderBasicStationService'));

  container.addTransient<INetworkConnectionService>(NetworkConnectionService, Symbol.for('INetworkConnectionService'));
  container.addTransient<INetworkDeviceService>(NetworkDeviceService, Symbol.for('INetworkDeviceService'));
  container.addTransient<INetworkNetworkingService>(NetworkNetworkingService, Symbol.for('INetworkNetworkingService'));
  container.addTransient<INetworkProfileService>(NetworkProfileService, Symbol.for('INetworkProfileService'));

  container.addTransient<ISystemCertificateService>(SystemCertificateService, Symbol.for('ISystemCertificateService'));
  container.addTransient<ISystemHardwareService>(SystemHardwareService, Symbol.for('ISystemHardwareService'));
  container.addTransient<ISystemInfoService>(SystemInfoService, Symbol.for('ISystemInfoService'));
  container.addTransient<ISystemLogService>(SystemLogService, Symbol.for('ISystemLogService'));
  container.addTransient<ISystemOsService>(SystemOsService, Symbol.for('ISystemOsService'));
  container.addTransient<ISystemStatsService>(SystemStatsService, Symbol.for('ISystemStatsService'));
  container.addTransient<ISystemTimeService>(SystemTimeService, Symbol.for('ISystemTimeService'));
  container.addTransient<ISystemUpgradeService>(SystemUpgradeService, Symbol.for('ISystemUpgradeService'));
  container.addTransient<ISystemUpdateService>(SystemUpdateService, Symbol.for('ISystemUpdateService'));
  container.addTransient<ISystemStorageService>(SystemStorageService, Symbol.for('ISystemStorageService'));

  container.addTransient<IGatewaySettingsService>(GatewaySettingsService, Symbol.for('IGatewaySettingsService'));
  container.addTransient<ILocalSettingsService>(LocalSettingsService, Symbol.for('ILocalSettingsService'));
  container.addTransient<ISettingsService>(SettingsService, Symbol.for('ISettingsService'));

  container.addSingleton<AuthStore>(AuthStore, Symbol.for('AuthStore'));
  container.addSingleton<MessagingStore>(MessagingStore, Symbol.for('MessagingStore'));
}
